import React from 'react';
import { Box, Typography } from 'housecall-ui';

import { AmplitudeFlagKeys } from '../resources/amplitude/amplitudeFlags';
import useIsExperimentActive from '../resources/amplitude/useIsExperimentActive';

import { ProgressBar } from './ProgressBar';

type Props = {
  currentStep: number;
  stepCount: number;
};

export const StepProgressBar = ({ currentStep, stepCount }: Props) => {
  const hideStepper = useIsExperimentActive(AmplitudeFlagKeys.obHideStepper);
  const showLabel = !hideStepper;

  return (
    <div>
      {showLabel && (
        <Typography variant="subtitle2">
          Step {currentStep} of {stepCount}
        </Typography>
      )}
      <Box mt={showLabel ? 2 : 5}>
        <ProgressBar value={currentStep} maxValue={stepCount} />
      </Box>
    </div>
  );
};
